import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { Tabs } from "antd";
import { AppstoreOutlined } from "@ant-design/icons";

// import Loader from "dumbComponents/common/UI/Loader"
import { DownOutlined } from "@ant-design/icons";
import NumberFormat from "react-number-format";
import { SearchOutlined } from "@ant-design/icons";
import {
  Input,
  Space,
  Dropdown,
  Menu,
  DatePicker,
  Divider,
  Select,
  Button as ClassicButton,
} from "antd";
import { Table, message, Upload, Modal } from "antd";
import Loader from "dumbComponents/common/UI/Loader";
import container from "container/BrokerDashboard/globalPagesContainer";
import agentSearchContainer from "container/BrokerDashboard/agentSearchContainer";
import teamContainer from "container/BrokerDashboard/teamContainer.js";
import InfiniteScroll from "react-infinite-scroller";
import moment from "moment-timezone";
import {
  MoreOutlined,
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import NewRoster from "../GlobalPages/NewRoster";
import { formatDate } from "../AgentDashboard/Util";
import { get } from "lodash";

const FilterWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0px 20px;
  gap: 24px;
`;

const OuterWrap = styled.div`
  padding: 0px 73px 20px 73px;
`;

const StyledInput = styled(Input)`
  width: ${(props) => props.width || "200px"} !important;
  height: 41px !important;
  border-radius: 8px !important;
  font-size: 16px;
  position: relative;
  .ant-input-prefix {
    margin-right: 8px;
  }
`;
const BorderWrap = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 14px;
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .ant-tabs-tab {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    padding: 8px 24px;
  }

  .ant-tabs-tab-active {
    color: #6366f1;
    background: #eef2ff;
    border-bottom: 2px solid #4f46e5;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 0;
  }

  .ant-tabs-tab:hover {
    background: #eef2ff;
  }
`;

const AgentItem = styled.div`
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  &:hover {
    background: #eee;
    transition-duration: 0.3s;
    cursor: pointer;
  }
  > div {
    &:nth-child(1) {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      overflow: hidden;
      background: #eee;
      > img {
        width: 100%;
      }
    }
    &:nth-child(2) {
      margin-left: 20px;
      p,
      h6 {
        padding: 0px;
        margin: 0px;
      }
      h6 {
        font-weight: 400;
        color: #999;
        font-size: 12px;
      }
      > input {
        color: #999;
        border: 10px;
        font-size: 12px;
        pointer-events: none;
        padding: 0px;
        background: transparent;
      }
    }
  }
`;

const { TabPane } = Tabs;

const SearchDropdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  width: ${(props) => props.width || "200px"} !important;
  cursor: pointer;
  height: 41px;
`;

const StyledDatePicker = styled(DatePicker)`
  border-radius: 8px !important;
  padding: 8px 12px;
  font-size: 16px;

  &:hover,
  &:focus {
    box-shadow: none !important;
  }

  .ant-picker-input > input {
    color: #9ca3af;
    text-align: left;
  }

  .ant-picker-suffix {
    color: #9ca3af;
  }
`;
const DatePickerContainer = styled.div`
  width: ${(props) => props.width || "200px"} !important;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
`;

const InputGroup = styled.div`
  display: flex;
  width: ${(props) => props.width || "200px"} !important;
  flex-direction: column;
  gap: 6px;
`;

const InputRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 0;
`;

const StyledCurrencyInput = styled(Input)`
  height: 41px;
  border-radius: 8px !important;
  border: 1px solid #e5e7eb !important;
  font-size: 16px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  padding: 0px !important;

  .ant-input {
    border: none !important;
    box-shadow: none !important;
    padding-left: 8px !important;
    margin: 0px !important;
  }

  .ant-input-prefix {
    background: #e5e7eb;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-right: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 100%;
    font-size: 16px;
    margin: 0px !important;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 18px;
  margin-top: 10px;
`;

const SuggestionsList = styled.ul`
  position: absolute;
  top: 130px; /* Ensures it appears just below the input */
  width: 32.6%;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  list-style: none;
  padding: 8px 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

const SuggestionItem = styled.li`
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  background: #ddd;
`;
const InputWrapper = styled.div`
  width: ${(props) => props.width || "313px"} !important;

  position: relative; /* Ensures AgentList is positioned relative to this container */
  width: fit-content; /* Adjusts width to fit the input and dropdown */
`;
const AgentList = styled.div`
  position: absolute;
  width: 100%;
  top: 100%;
  left: 0;
  background: #fff;
  border-radius: 10px;
  z-index: 1000;
  height: max-content;

  ${(props) =>
    props.hasAgents &&
    `
     border: 1px solid #ccc;
   `}

  ${(props) =>
    props.hideDropdown &&
    `
     display: none;
    `}
`;

const AgentDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const AgentName = styled.div`
  font-weight: bold;
`;

const AgentEmail = styled.div`
  font-size: 14px;
  color: gray;
`;

const AgentPhone = styled.div`
  font-size: 14px;
  color: gray;
`;

const StyledTableWrapper = styled.div`
  .ant-table .ant-table-header .ant-table-cell-fix-left {
    background: white !important;
  }

  .ant-table .ant-table-cell-fix-left {
    background: #fff;
    z-index: 2 !important;
    box-shadow: none !important;
  }

  /* Fixed header styling */
  .ant-table-header {
    position: sticky !important;
    top: 0 !important;
    z-index: 3 !important;
    background: white !important;
  }

  /* Fixed first row styling */
  .ant-table-tbody tr:first-child {
    position: sticky !important;
    top: 0 !important;
    z-index: 2 !important;
    background: white !important;
  }

  /* Ensure proper z-index for fixed elements */
  .ant-table-thead > tr > th {
    position: sticky !important;
    top: 0 !important;
    z-index: 3 !important;
    background: white !important;
  }

  /* Container for proper scrolling */
  .ant-table-container {
    max-height: 70vh;
    overflow: auto;
  }

  /* Ensure table body can scroll */
  .ant-table-body {
    overflow: auto !important;
  }

  /* Ensure fixed left column has proper styling */
  .ant-table-cell-fix-left {
    background: white !important;
    z-index: 4 !important;
  }

  .ant-table-thead .ant-table-cell-fix-left {
    background: white !important;
    z-index: 5 !important;
  }
`;

const FilterBoard = ({
  getAllAgentsForRosterPage,
  getAllAccountsForRosterPage,
  getSaasAccountsForRosterPage,
  data,
  isAgentListDropdownVisible,
  isFetchingMore,
  isFetching,
  downloadAllAccountsRosterPage,
  downloadAllSaasAccountsRosterPage,
  downloadAllAgentsRosterPage,
  rosterPageAllAgentsResponse,
  rosterPageAllAccountsResponse,
  rosterPageSaasAccountsResponse,
  uploadW2Form,
  deleteW2Form,
  rosterFetchAgentSearch,
  updateAdditionalArCollected,
  agents,
  toggleAgentList,
  uploadW2FormResponse,
  key,
  ...props
}) => {
  const handlesearchByAccount = (value) => {
    setSearchByAccount(value);
  };

  const sortFunctionKeysForAgents = (key) => {
    if (key == "createdDate") return "createdAtSortOrder";
    if (key == "agentName") return "agentNameSortOrder";
    if (key == "agentEmail") return "agentEmailSortOrder";
    if (key == "accountName") return "accountNameSortOrder";
    if (key == "role") return "agentTypeSortOrder";
    if (key == "brokerageDate") return "brokerageJoinDateSortOrder";
    if (key == "churnedDate") return "churnedSortOrder";
    if (key == "dealsClosed") return "dealsClosedSortOrder";
    if (key == "dealsInContract") return "dealsInContractsSortOrder";
    if (key == "listingsActive") return "listingsSortOrder";
    if (key == "totalProduction") return "totalProductionSortOrder";
    if (key == "last12MonthsProduction")
      return "last12MonthsProductionSortOrder";
    if (key == "totalGrossCommission") return "totalGrossCommissionSortOrder";
    if (key == "totalAgentCommission") return "totalAgentCommissionSortOrder";
    if (key == "cap") return "capSortOrder";
    if (key == "totalRadiusTransactionRevenue")
      return "totalRadiusFeesSortOrder";
    if (key == "accountsReceivableEO") return "arEoSortOrder";
    if (key == "accountsReceivableManual") return "arManualSortOrder";
    if (key == "accountsReceivableBroker") return "arBrokerSortOrder";
    if (key == "totalAccountReceivable") return "arTotalSortOrder";
  };

  const sortFunctionKeysForAccounts = (key) => {
    if (key == "createdDate") return "createdAtSortOrder";
    if (key == "brokerageDate") return "brokerageJoinDateSortOrder";
    if (key == "churnedDate") return "churnedSortOrder";
    if (key == "dealsClosed") return "dealsClosedSortOrder";
    // if (key == "agentName") return "agentNameSortOrder";
    // if (key == "agentEmail") return "agentEmailSortOrder";
    if (key == "accountName") return "accountNameSortOrder";
    if (key == "type") return "accountTypeSortOrder";
    if (key == "teamSize") return "teamSizeSortOrder";
    if (key == "dealsInContract") return "dealsInContractsSortOrder";
    if (key == "listingsActive") return "listingsSortOrder";
    if (key == "totalProduction") return "totalProductionSortOrder";
    if (key == "last12MonthsProduction")
      return "last12MonthsProductionSortOrder";
    if (key == "totalGrossCommission") return "totalGrossCommissionSortOrder";
    if (key == "totalAgentCommission") return "totalAgentCommissionSortOrder";
    if (key == "totalRadiusTransactionRevenue")
      return "totalRadiusFeesSortOrder";
  };

  const sortFunctionKeysForSaasAccounts = (key) => {
    if (key == "createdDate") return "createdAtSortOrder";
    if (key == "subsDate") return "subsDateSortOrder";
    if (key == "churnedDate") return "churnedSortOrder";
    if (key == "aiCreditsPaid") return "aiCreditsPaidSortOrder";
    if (key == "aiCreditsConsumed") return "aiCreditsConsumedSortOrder";
    if (key == "aiCreditsAvailable") return "aiCreditsAvailableSortOrder";
    if (key == "clientAppLogins") return "clientAppLoginsSortOrder";
  };
  const [searchByClient, setSearchByClient] = useState("");
  const [search, setSearch] = useState(true);
  const [searchByAccount, setSearchByAccount] = useState("");
  const { isFetching: isFetchingName, data: dataAgent } = agents;
  const [downloadRequest, setDownloadRequest] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [brokerageJoinDate, setBrokerageJoinDate] = useState([null, null]);
  const [churnedDate, setChurnedDate] = useState([null, null]);
  const [createdDate, setCreatedDate] = useState([null, null]);
  const [dealsClosedRange, setDealsClosedRange] = useState(["", ""]);
  const [transactionRevenueRange, setTransactionRevenueRange] = useState([
    "",
    "",
  ]);
  const [showChurnedAgents, setShowChurnedAgents] = useState(0);
  const [showChurnedAccounts, setShowChurnedAccounts] = useState(0);

  const [isW2ModalOpen, setW2Modal] = useState(false);
  const [hasFetchedAccounts, setHasFetchedAccounts] = useState(false);
  const [hasFetchedAgents, setHasFetchedAgents] = useState(false);
  const [hasFetchedSaasAccounts, setHasFetchedSaasAccounts] = useState(false);
  const [totalSaasCount, setTotalSaasCount] = useState(100);
  const [totalAgentCount, setTotalAgentCount] = useState(100);
  const [totalAccountCount, setTotalAccountCount] = useState(100);
  const [selectedSaasAccountType, setSelectedSaasAccountType] = useState(null);
  const [selectedBrokerAccountType, setSelectedBrokerAccountType] = useState(
    null
  );
  const agentsLists = get(dataAgent, "agents", []);

  const [accountData, setAccountData] = useState([]);
  const [saasUsersData, setSaasUsersData] = useState([]);
  const [agentData, setAgentData] = useState([]);

  const [isFetchingAccounts, setIsFetchingAccounts] = useState(true);
  const [isFetchingSaasData, setIsFetchingSaasData] = useState(true);
  const [isFetchingAgentData, setIsFetchingAgentData] = useState(true);

  const [w2deletionModal, setW2deletionModal] = useState(false);
  const [selectedW2File, setW2File] = useState(null);
  const [agentIdForW2, setAgentIdForW2] = useState(null);
  const [selectedSplit, setSelectedSplit] = useState(null);
  const [selectedCap, setSelectedCap] = useState(null);
  const [selectedTeamsize, setSelectedTeamsize] = useState(null);
  const [minTotalProductionRange, setMinTotalProductionRange] = useState("");
  const [maxTotalProductionRange, setMaxTotalProductionRange] = useState("");
  const [
    last12MonthsProductionRange,
    setLast12MonthsProductionRange,
  ] = useState(["", ""]);
  const [creditAvailable, setCreditsAvailable] = useState(["", ""]);
  const [creditPaid, setCreditsPaid] = useState(["", ""]);
  const [creditConsumed, setCreditsConsumed] = useState(["", ""]);
  const [capRange, setCapRange] = useState(null);
  // const [seeFilters, setSeeFilters] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingRowId, setEditingRowId] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [activeTab, setActiveTab] = useState("2");
  const [loaderActive, setLoaderActive] = useState(false);
  const [fetchedCount, setFetchedCount] = useState(0);
  const inputWrapperRef = useRef(null);
  const [agentSkip, setAgentSkip] = useState(0);
  const [accountSkip, setAccountSkip] = useState(0);
  const [saasSkip, setSaasSkip] = useState(0);
  // const [isFetchingMoreAgentData,setIsFetchingMoreAgentData]= useState(true);

  const [limit, setLimit] = useState(100);
  const [sortConfig, setSortConfig] = useState({ key: null, order: null });
  const [sortAccountsConfig, setAccountsSortConfig] = useState({
    key: null,
    order: null,
  });
  const [sortSaasAccountsConfig, setSaasAccountsSortConfig] = useState({
    key: null,
    order: null,
  });
  const { Option } = Select;
  const handleChangeTab = (key) => {
    setActiveTab(key);
  };

  const createPayloadForAgents = (extra = {}, clearSkip = false) => {
    const payload = {
      limit: 100,
      ...extra,
    };

    // if (brokerageJoinDate) {
    //   const dateObj = new Date(brokerageJoinDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.brokerageJoinDate = moment(dateObj).unix();
    // }
    if (dealsClosedRange[0]) {
      payload.dealsClosedMin = dealsClosedRange[0];
    }
    if (showChurnedAgents) {
      payload.churnedFilter = 1;
    }
    if (dealsClosedRange[1]) {
      payload.dealsClosedMax = dealsClosedRange[1];
    }
    if (createdDate[0]) {
      const dateObj = new Date(createdDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.createDateMin = moment(dateObj).unix();
    }
    if (createdDate[1]) {
      const dateObj = new Date(createdDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.createDateMax = moment(dateObj).unix();
    }
    if (brokerageJoinDate[0]) {
      const dateObj = new Date(brokerageJoinDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.brokerageJoinDateMin = moment(dateObj).unix();
    }
    if (brokerageJoinDate[1]) {
      const dateObj = new Date(brokerageJoinDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.brokerageJoinDateMax = moment(dateObj).unix();
    }
    if (churnedDate[0]) {
      const dateObj = new Date(churnedDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.churnedDateMin = moment(dateObj).unix();
    }
    if (churnedDate[1]) {
      const dateObj = new Date(churnedDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.churnedDateMax = moment(dateObj).unix();
    }
    // if (churnedDate) {
    //   const dateObj = new Date(churnedDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.churnedDate = moment(dateObj).unix();
    // }
    if (transactionRevenueRange[0]) {
      payload.totalTransactionRevenueMin = transactionRevenueRange[0];
    }
    if (transactionRevenueRange[1]) {
      payload.totalTransactionRevenueMax = transactionRevenueRange[1];
    }
    if (minTotalProductionRange) {
      payload.totalProductionMin = minTotalProductionRange;
    }
    if (maxTotalProductionRange) {
      payload.totalProductionMax = maxTotalProductionRange;
    }
    if (last12MonthsProductionRange[0]) {
      payload.lastYearProductionMin = last12MonthsProductionRange[0];
    }
    if (last12MonthsProductionRange[1]) {
      payload.lastYearProductionMax = last12MonthsProductionRange[1];
    }
    if (searchByAccount) {
      payload.accountName = searchByAccount;
    }
    if (selectedSplit) {
      payload.split = selectedSplit;
    }

    // if (createdDate) {
    //   const dateObj = new Date(createdDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.createDate = moment(dateObj).unix();
    // }
    if (searchByClient) {
      payload.agentEmail = encodeURIComponent(searchByClient);
    }
    if (selectedRole) {
      payload.agentType = selectedRole;
    }
    if (selectedStatus) {
      payload.subsStatus = selectedStatus;
    }
    if (capRange) {
      payload.cap = capRange;
    }

    return payload;
  };

  const { isFetching: isFetchingW2 } = uploadW2FormResponse;

  const createPayloadForAccounts = (extra = {}, clearSkip = false) => {
    const payload = {
      limit: limit,
      ...extra,
    };

    if (sortAccountsConfig.key && sortAccountsConfig.order) {
      payload.sortBy = `${sortAccountsConfig.key}=${sortAccountsConfig.order}`;
    }

    if (searchByAccount) {
      payload.accountName = searchByAccount;
    }
    if (showChurnedAccounts) {
      payload.churnedFilter = 1;
    }
    if (createdDate[0]) {
      const dateObj = new Date(createdDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.createDateMin = moment(dateObj).unix();
    }
    if (createdDate[1]) {
      const dateObj = new Date(createdDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.createDateMax = moment(dateObj).unix();
    }
    if (brokerageJoinDate[0]) {
      const dateObj = new Date(brokerageJoinDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.brokerageJoinDateMin = moment(dateObj).unix();
    }
    if (brokerageJoinDate[1]) {
      const dateObj = new Date(brokerageJoinDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.brokerageJoinDateMax = moment(dateObj).unix();
    }
    if (churnedDate[0]) {
      const dateObj = new Date(churnedDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.churnedDateMin = moment(dateObj).unix();
    }
    if (churnedDate[1]) {
      const dateObj = new Date(churnedDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.churnedDateMax = moment(dateObj).unix();
    }
    if (selectedBrokerAccountType) {
      payload.accountType = selectedBrokerAccountType;
    }
    if (selectedTeamsize) {
      payload.teamSize = selectedTeamsize;
    }
    // if (brokerageJoinDate) {
    //   const dateObj = new Date(brokerageJoinDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.brokerageJoinDate = moment(dateObj).unix();
    // }
    // if (createdDate) {
    //   const dateObj = new Date(createdDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.createDate = moment(dateObj).unix();
    // }
    // if (churnedDate) {
    //   const dateObj = new Date(churnedDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.churnedDate = moment(dateObj).unix();
    // }
    if (dealsClosedRange[0]) {
      payload.minDealsClosed = dealsClosedRange[0];
    }
    if (dealsClosedRange[1]) {
      payload.maxDealsClosed = dealsClosedRange[1];
    }
    if (transactionRevenueRange[0]) {
      payload.minTransactionRevenue = transactionRevenueRange[0];
    }
    if (transactionRevenueRange[1]) {
      payload.maxTransactionRevenue = transactionRevenueRange[1];
    }
    if (minTotalProductionRange) {
      payload.minTotalProduction = minTotalProductionRange;
    }
    if (maxTotalProductionRange) {
      payload.maxTotalProduction = maxTotalProductionRange;
    }
    if (last12MonthsProductionRange[0]) {
      payload.minLastYearProduction = last12MonthsProductionRange[0];
    }
    if (last12MonthsProductionRange[1]) {
      payload.maxLastYearProduction = last12MonthsProductionRange[1];
    }
    if (selectedSplit) {
      payload.split = selectedSplit;
    }

    return payload;
  };

  const createPayloadForSaasAccounts = (extra = {}, clearSkip = false) => {
    const payload = {
      limit: limit,
      ...extra,
    };
    if (selectedSaasAccountType) {
      payload.accountType = selectedSaasAccountType;
    }
    if (searchByAccount) {
      payload.name = searchByAccount;
    }

    // if (brokerageJoinDate) {
    //   const dateObj = new Date(brokerageJoinDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.brokerageJoinDate = moment(dateObj).unix();
    // }
    // if (churnedDate) {
    //   const dateObj = new Date(churnedDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.churnedDate = moment(dateObj).unix();
    // }
    // if (createdDate) {
    //   const dateObj = new Date(createdDate);
    //   dateObj.setHours(0, 0, 0, 0);
    //   payload.createDate = moment(dateObj).unix();
    // }
    if (createdDate[0]) {
      const dateObj = new Date(createdDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.createDateMin = moment(dateObj).unix();
    }
    if (createdDate[1]) {
      const dateObj = new Date(createdDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.createDateMax = moment(dateObj).unix();
    }
    if (brokerageJoinDate[0]) {
      const dateObj = new Date(brokerageJoinDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.brokerageJoinDateMin = moment(dateObj).unix();
    }
    if (brokerageJoinDate[1]) {
      const dateObj = new Date(brokerageJoinDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.brokerageJoinDateMax = moment(dateObj).unix();
    }
    if (churnedDate[0]) {
      const dateObj = new Date(churnedDate[0]);
      dateObj.setHours(0, 0, 0, 0);
      payload.churnedDateMin = moment(dateObj).unix();
    }
    if (churnedDate[1]) {
      const dateObj = new Date(churnedDate[1]);
      dateObj.setHours(0, 0, 0, 0);
      payload.churnedDateMax = moment(dateObj).unix();
    }
    if (creditPaid[0]) {
      payload.aiCreditsPaidMin = creditPaid[0];
    }
    if (creditPaid[1]) {
      payload.aiCreditsPaidMax = creditPaid[1];
    }

    if (creditConsumed[0]) {
      payload.aiCreditsConsumedMin = creditConsumed[0];
    }
    if (creditConsumed[1]) {
      payload.aiCreditsConsumedMax = creditConsumed[1];
    }
    if (creditAvailable[0]) {
      payload.aiCreditsAvailableMin = creditAvailable[0];
    }
    if (creditAvailable[1]) {
      payload.aiCreditsAvailableMax = creditAvailable[1];
    }

    return payload;
  };

  const formatRoleDropdown = (role) => {
    if (role === "admin") return "Team lead";
    if (role === "co_team_lead") return "Co-team lead";
    if (role === "individual_agent") return "Individual agent";
    if (role === "associate") return "Associate";
    if (role === "assistant") return "Assistant";
    if (role === "team_tc") return "Team TC";
    if (role === "All") return "All";
    if (role === "team") return "Team";
  };

  const handleDownload = async () => {
    setLoaderActive(true);
    try {
      if (activeTab == "1") {
        downloadAllAccountsRosterPage(createPayloadForAccounts({}, true));
      }
      if (activeTab == "2") {
        await downloadAllAgentsRosterPage(createPayloadForAgents({}, true));
      }
      if (activeTab == "3") {
        downloadAllSaasAccountsRosterPage(
          createPayloadForSaasAccounts({}, true)
        );
      }
    } catch (error) {
      console.log("Error downloading file:", error);
    } finally {
      setLoaderActive(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputWrapperRef.current &&
        !inputWrapperRef.current.contains(event.target)
      ) {
        toggleAgentList(false); // Hide AgentList on outside click
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (activeTab == "1") {
      setSkip(0);
      const accountPayload = createPayloadForAccounts();
      getAllAccountsForRosterPage(accountPayload);
    }
    if (activeTab == "2") {
      setSkip(0);
      const agentPayload = createPayloadForAgents();
      getAllAgentsForRosterPage(agentPayload);
    }
    if (activeTab == "3") {
      setSkip(0);
      const saasAccountPayload = createPayloadForSaasAccounts();
      getSaasAccountsForRosterPage(saasAccountPayload);
    }
  }, [search]);
  // const [fetchMoreKey,setFetchMoreKey]=useState(true);
  //   useEffect(() => {
  //     if (activeTab == "1") {
  //       // setSkip(0);
  //       const accountPayload = {
  //         ...createPayloadForAgents(),
  //         isFetchingMore: true
  //       };
  //       getAllAccountsForRosterPage(accountPayload);
  //     }
  //     if (activeTab == "2") {
  //       // setSkip(0);
  //       const agentPayload = {
  //         ...createPayloadForAgents(),
  //         isFetchingMore: true
  //       };
  //       getAllAgentsForRosterPage(agentPayload);
  //     }
  //     if (activeTab == "3") {
  //       // setSkip(0);
  //       const saasAccountPayload = {
  //         ...createPayloadForAgents(),
  //         isFetchingMore: true
  //       };
  //       getSaasAccountsForRosterPage(saasAccountPayload);
  //     }
  //   },[fetchMoreKey])

  //   const fetchMore = () => setFetchMoreKey((prev) => !prev)
  const handleLimitChange = (value) => {
    setLimit(value); 
    setSkip(0); 
  };
  useEffect(() => {
    clearFilterValues();
    const accountPayload = {
      ...createPayloadForAccounts(),
      churnedFilter: showChurnedAgents ? 1 : 0,
    };
    getAllAgentsForRosterPage(accountPayload);
  }, [showChurnedAgents]);
  useEffect(() => {
    clearFilterValues();
    const accountPayload = {
      ...createPayloadForAccounts(),
      churnedFilter: showChurnedAccounts ? 1 : 0,
    };
    getAllAccountsForRosterPage(accountPayload);
  }, [showChurnedAccounts]);

  const actionItems = [
    {
      key: "w2_integration",
      label: "Add/Edit 1099",
    },
    {
      key: "w2_deletion",
      label: "Delete 1099",
    },
  ];

  const saasMenuItems = [
    {
      key: "view_team",
      label: "View team",
    },
    {
      key: "edit_account",
      label: "Edit Account Details",
    },
    {
      key: "view_product_analytics",
      label: "View Product Analytics",
    },
  ];

  const clearFilterValues = () => {
    setMinTotalProductionRange("");
    setMaxTotalProductionRange("");
    setLast12MonthsProductionRange(["", ""]);
    setCreditsAvailable(["", ""]);
    setSelectedTeamsize(null);
    setCreditsPaid(["", ""]);
    setCreditsConsumed(["", ""]);
    setCapRange(["", ""]);
    setSortConfig({ key: null, order: null });
    setAccountsSortConfig({ key: null, order: null });
    setSaasAccountsSortConfig({ key: null, order: null });
    setSearchByAccount("");
    setSelectedRole(null);
    setSelectedStatus(null);
    setSelectedBrokerAccountType(null);
    setSelectedSaasAccountType(null);
    setBrokerageJoinDate(["", ""]);
    setChurnedDate(["", ""]);
    setCreatedDate(["", ""]);
    setDealsClosedRange(["", ""]);
    setTransactionRevenueRange(["", ""]);
    setCapRange(null);
    setSelectedSplit(null);
    setSearchByClient("");
  };

  const handleClearFilter = () => {
    if (activeTab == "1") getAllAccountsForRosterPage({ limit: limit });
    if (activeTab == "2") getAllAgentsForRosterPage({ limit: limit });
    if (activeTab == "3") getSaasAccountsForRosterPage({ limit: limit });
    clearFilterValues();
  };

  const handleSortForAgents = (columnKey, order) => {
    setSortConfig({ key: columnKey, order });
    const payload = {
      ...createPayloadForAgents(),
      skip: 0,
    };

    if (order) {
      payload.sortBy = `${columnKey}=${order}`;
    }

    getAllAgentsForRosterPage(payload);
  };

  const handleSortForAccounts = (columnKey, order) => {
    setAccountsSortConfig({ key: columnKey, order });
    const payload = {
      ...createPayloadForAccounts(),
      skip: 0,
    };

    if (order) {
      payload.sortBy = `${columnKey}=${order}`;
    }

    getAllAccountsForRosterPage(payload);
  };

  const handleSortForSaasAccounts = (columnKey, order) => {
    setSaasAccountsSortConfig({ key: columnKey, order });
    const payload = {
      ...createPayloadForSaasAccounts(),
      skip: 0,
    };

    if (order) {
      payload.sortBy = `${columnKey}=${order}`;
    }

    getSaasAccountsForRosterPage(payload);
  };

  const handleRoleSelect = (e) => {
    setSelectedRole(e.key === "All" ? null : e.key);
  };

  const handleSubsStatusSelect = (e) => {
    setSelectedStatus(e.key);
  };

  const handleSplitSelect = (e) => {
    setSelectedSplit(e.key === "All" ? null : e.key);
  };

  const handleSaasAccountSelect = (e) => {
    setSelectedSaasAccountType(e.key);
  };

  const handleBrokerAccountSelect = (e) => {
    setSelectedBrokerAccountType(e.key);
  };

  const handleTeamSelect = (e) => {
    setSelectedTeamsize(e.key === "All" ? null : e.key);
  };

  const accountTypeLabel = (type) => {
    if (type === "individual_agent") return "Individual Agent";
    if (type === "team") return "Team";
  };

  const roleitems = (
    <Menu onClick={handleRoleSelect}>
      <Menu.Item key="admin">Team Lead</Menu.Item>
      <Menu.Item key="co_team_lead">Co Team Lead</Menu.Item>
      <Menu.Item key="individual_agent">Individual Agent</Menu.Item>
      <Menu.Item key="associate">Associate</Menu.Item>
      <Menu.Item key="assistant">Assistant</Menu.Item>
      <Menu.Item key="team_tc">Team TC</Menu.Item>
    </Menu>
  );

  const subsStatusItems = (
    <Menu onClick={handleSubsStatusSelect}>
      <Menu.Item key="Payment Failed">Payment failed</Menu.Item>
      <Menu.Item key="Paid">Paid</Menu.Item>
    </Menu>
  );

  const teamSizeOptions = (
    <Menu onClick={handleTeamSelect}>
      <Menu.Item key="lessThan10">{" < 10"}</Menu.Item>
      <Menu.Item key="greaterThan10">{"10 + "}</Menu.Item>
      <Menu.Item key="greaterThan20">{"20 + "}</Menu.Item>
      <Menu.Item key="greaterThan50">{"50 + "}</Menu.Item>
    </Menu>
  );

  const splitItems = (
    <Menu onClick={handleSplitSelect}>
      <Menu.Item key="Flagship partner plan (95/5 until $500K, 97/3 after)">
        Flagship partner plan (95/5 until $500K, 97/3 after)
      </Menu.Item>
      <Menu.Item key="Partner plan (90/10 with cap)">
        Partner plan (90/10 with cap)
      </Menu.Item>
      <Menu.Item key="No Split">No Split</Menu.Item>
      <Menu.Item key="80/20">80/20</Menu.Item>
      <Menu.Item key="90/10">90/10</Menu.Item>
      <Menu.Item key="95/5">95/5</Menu.Item>
      <Menu.Item key="92/8">92/8</Menu.Item>
      <Menu.Item key="Flat Fee">Flat Fee</Menu.Item>
    </Menu>
  );

  const accountTypeSaasItems = (
    <Menu onClick={handleSaasAccountSelect}>
      <Menu.Item key="individual_agent">Individual Agent</Menu.Item>
      <Menu.Item key="team">Team</Menu.Item>
    </Menu>
  );

  const accountTypeBrokerItems = (
    <Menu onClick={handleBrokerAccountSelect}>
      <Menu.Item key="Individual Agent">Individual Agent</Menu.Item>
      <Menu.Item key="Team">Team</Menu.Item>
    </Menu>
  );

  const getData = () => {
    if (activeTab === "1" && !hasFetchedAccounts) {
      const { data, isFetching } = rosterPageAllAccountsResponse;

      setAccountData(data || []);
      setTotalAccountCount(data?.overview?.total_accounts || 0);
      setIsFetchingAccounts(isFetching);
      setFetchedCount(data?.result?.length);
    }

    if (activeTab === "3" && !hasFetchedSaasAccounts) {
      const { data, isFetching } = rosterPageSaasAccountsResponse || {};
      setSaasUsersData(data || []);
      setTotalSaasCount(data?.overview?.total_accounts || 0);
      setIsFetchingSaasData(isFetching);
      setFetchedCount(data?.result?.length);
    }

    if (activeTab === "2" && !hasFetchedAgents) {
      const {
        data,
        count,
        isFetching,
        isFetchingMore,
      } = rosterPageAllAgentsResponse;
      setAgentData(data || []);
      setTotalAgentCount(data?.overview?.total_agents || 0);
      setIsFetchingAgentData(isFetching);
      // setIsFetchingMoreAgentData(isFetchingMore);
      setFetchedCount(data?.result?.length);
    }
  };

  useEffect(() => {
    handleClearFilter();
  }, [activeTab]);

  useEffect(() => {
    getData();
  }, [
    rosterPageAllAccountsResponse,
    rosterPageAllAgentsResponse,
    rosterPageSaasAccountsResponse,
  ]);

  const handleMenuClick = (e, agentData) => {
    if (e.key === "w2_integration") {
      setW2Modal(true);
      setAgentIdForW2(agentData.id);
    }
    if (e.key === "w2_deletion") {
      setW2deletionModal(true);
      setAgentIdForW2(agentData.id);
    }
  };
  const handleSaasMenuClick = (e, saasData) => {
    if (e.key === "view_team") {
    }
    if (e.key === "view_product_analytics") {
    }
    if (e.key === "edit_account") {
    }
  };
  const menu = (agentData) => (
    <Menu onClick={(e) => handleMenuClick(e, agentData)}>
      {actionItems.map((item) => (
        <Menu.Item key={item.key}>{item.label}</Menu.Item>
      ))}
    </Menu>
  );

  const saasMenu = (saasData) => {
    const filteredMenuItems = saasMenuItems.filter((item) => {
      if (item.key === "view_team" && saasData.type === "individual_agent") {
        return false;
      }
      return true;
    });
    return (
      <Menu>
        {filteredMenuItems.map((item) => (
          <Menu.Item key={item.key}>
            {item.key === "view_team" ? (
              <Link to={`/broker/teams/edit/${saasData.team_id}`}>
                {item.label}
              </Link>
            ) : (
              <span
                onClick={(e) =>
                  handleSaasMenuClick({ key: item.key }, saasData)
                }
              >
                {item.label}
              </span>
            )}
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  const handleOk = () => {
    if (!selectedW2File) {
      message.error("Please select file to upload");
    } else {
      const bucketLocation = "w2-documents";
      const timestamp = Date.now();
      const file_name = `${timestamp}_${selectedW2File.name}`;

      uploadW2Form({
        file: selectedW2File,
        objName: file_name,
        fileName: file_name,
        bucketName:
          process.env.REACT_APP_NODE_ENV === "production"
          ? bucketLocation
            : `s-${bucketLocation}`,
        agentId: agentIdForW2,
        callback: () => {
          setW2Modal(false);
          setW2File(null);
          window.location.reload();
        },
      });
    }
  };

  const handleCancel = () => {
    setW2Modal(false);
    setW2File(null);
    setAgentIdForW2(null);
  };

  const handleRemove = () => {
    setW2File(null);
  };
  const handleUpload = (file) => {
    const isPDF = file.type === "application/pdf";

    if (!isPDF) {
      message.error(`${file.name} is not a PDF file`);
      return Upload.LIST_IGNORE;
    }

    setW2File(file);
    return true;
  };

  const handleDeleteOk = () => {
    setW2deletionModal(false);
    deleteW2Form({
      agentId: agentIdForW2,
      callback: () => {
        window.location.reload();
      },
    });
  };
  const handleDeleteCancel = () => {
    setW2deletionModal(false);
  };

  const getSubStatus = (type) => {
    if (
      [
        "incomplete",
        "incomplete_expired",
        "overdue",
        "past_due",
        "paused",
        "unpaid",
        "canceled",
      ].includes(type)
    ) {
      return "Payment failed";
    } else {
      return "Paid";
    }
  };

  const getFormattedExpiryDate = (date,status) => {
    if(date === null || date === undefined)
      return null;
    
    if(status === "incomplete_expired") 
    {
      const d = new Date(date);
      return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long", // full month name like "June"
        day: "numeric", // day of the month
      });
      // return date;
    }
      else
      return null;
  }

  const getExpiredSubStatus = (type) => {
    if(type === null)
      return "--"
    return type
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  }

  // const getExpiredSubStatus = (type) => {
  //   if(type === "incomplete_expired") 
  //     return "Expired";
  //     else
  //     return "Not Expired";
  // }

  const allAccountColumns = [
    {
      title: "Account name",
      dataIndex: "accountName",
      key: "accountName",
      align: "center",
      width: 220,
      fixed: 'left',
      // sorter: true,
      // showSorterTooltip: false,
      // onHeaderCell: (column) => ({
      //   onClick: () => {
      //     setSortConfig((prevConfig) => {
      //       const isCurrentlySorted = prevConfig.key === column.key;
      //       const newOrder =
      //         isCurrentlySorted && prevConfig.order === "ASC"
      //           ? "DESC"
      //           : prevConfig.order === "DESC"
      //           ? null
      //           : "ASC";
      //       handleSortForAgents(
      //         sortFunctionKeysForAgents(column.key),
      //         newOrder
      //       );
      //       return { key: column.key, order: newOrder };
      //     });
      //   },
      // }),
    },
    {
      title: "Team Size",
      dataIndex: "teamSize",
      key: "teamSize",
      width: 170,
      align: "center",
      // sorter: true,
      // showSorterTooltip: false,
      // onHeaderCell: (column) => ({
      //   onClick: () => {
      //     setSortConfig((prevConfig) => {
      //       const isCurrentlySorted = prevConfig.key === column.key;
      //       const newOrder =
      //         isCurrentlySorted && prevConfig.order === "ASC"
      //           ? "DESC"
      //           : prevConfig.order === "DESC"
      //           ? null
      //           : "ASC";
      //       handleSortForAgents(
      //         sortFunctionKeysForAgents(column.key),
      //         newOrder
      //       );
      //       return { key: column.key, order: newOrder };
      //     });
      //   },
      // }),
    },
    {
      title: "Account Type",
      dataIndex: "type",
      key: "type",
      width: 160,
      align: "center",
      // sorter: true,
      // showSorterTooltip: false,
      // onHeaderCell: (column) => ({
      //   onClick: () => {
      //     setSortConfig((prevConfig) => {
      //       const isCurrentlySorted = prevConfig.key === column.key;
      //       const newOrder =
      //         isCurrentlySorted && prevConfig.order === "ASC"
      //           ? "DESC"
      //           : prevConfig.order === "DESC"
      //           ? null
      //           : "ASC";
      //       handleSortForAgents(
      //         sortFunctionKeysForAgents(column.key),
      //         newOrder
      //       );
      //       return { key: column.key, order: newOrder };
      //     });
      //   },
      // }),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      align: "center",
      width: 160,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === "createdDate";
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: "createdDate", order: newOrder };
          });
        },
      }),
    },
    {
      title: "Brokerage Join Date",
      dataIndex: "brokerageDate",
      key: "brokerageDate",
      align: "center",
      width: 190,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Churned Date",
      dataIndex: "churnedDate",
      key: "churnedDate",
      align: "center",
      width: 170,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Commission Split",
      dataIndex: "commissionSplit",
      key: "commissionSplit",
      align: "center",
      width: 220,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: <span>Deals closed</span>,
      dataIndex: "dealsClosed",
      key: "dealsClosed",
      align: "center",
      sorter: true,
      width: 160,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Deals in contract",
      dataIndex: "dealsInContract",
      key: "dealsInContract",
      align: "center",
      width: 170,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },

    {
      title: "Listings Active",
      dataIndex: "listingsActive",
      key: "listingsActive",
      align: "center",
      width: 170,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Production",
      dataIndex: "totalProduction",
      key: "totalProduction",
      align: "center",
      sorter: true,
      width: 180,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Last 12 months production",
      dataIndex: "last12MonthsProduction",
      key: "last12MonthsProduction",
      align: "center",
      sorter: true,
      width: 240,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Gross Commission",
      dataIndex: "totalGrossCommission",
      key: "totalGrossCommission",
      align: "center",
      sorter: true,
      width: 230,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Agent Commission",
      dataIndex: "totalAgentCommission",
      key: "totalAgentCommission",
      align: "center",
      sorter: true,
      width: 230,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Radius Transaction Revenue",
      dataIndex: "totalRadiusTransactionRevenue",
      key: "totalRadiusTransactionRevenue",
      align: "center",
      sorter: true,
      width: 280,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAccounts(
              sortFunctionKeysForAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
  ];

  const allAgentColumns = [
    {
      title: "Agent name",
      dataIndex: "agentName",
      key: "agentName",
      width: 200,
      fixed: 'left',
      sorter: true,
      showSorterTooltip: false,
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Email",
      dataIndex: "agentEmail",
      align: "center",
      key: "agentEmail",
      width: 200,
      sorter: true,
      showSorterTooltip: false,
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },

    {
      title: "Account name",
      dataIndex: "accountName",
      key: "accountName",
      align: "center",
      width: 250,
      sorter: true,
      showSorterTooltip: false,
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      width: 180,
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      align: "center",
      width: 160,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === "createdDate";
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: "createdDate", order: newOrder };
          });
        },
      }),
    },
    {
      title: "Brokerage Join Date",
      dataIndex: "brokerageDate",
      key: "brokerageDate",
      align: "center",
      width: 200,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Churned Date",
      dataIndex: "churnedDate",
      key: "churnedDate",
      align: "center",
      width: 160,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Deals closed",
      dataIndex: "dealsClosed",
      key: "dealsClosed",
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      width: 150,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Deals in contract",
      dataIndex: "dealsInContract",
      key: "dealsInContract",
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      width: 170,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "First Deal Submitted",
      dataIndex: "firstDealSubmitted",
      key: "firstDealSubmitted",
      align: "center",
      width: 170,
    },
    {
      title: "First Deal Closed",
      dataIndex: "firstDealClosed",
      key: "firstDealClosed",
      align: "center",
      width: 170,
    },
    {
      title: "Listings Active",
      dataIndex: "listingsActive",
      key: "listingsActive",
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      width: 160,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Commission Split",
      dataIndex: "commissionSplit",
      key: "commissionSplit",
      align: "center",
      width: 220,
    },

    {
      title: "Cap",
      dataIndex: "cap",
      key: "cap",
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      width: 110,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Production",
      dataIndex: "totalProduction",
      key: "totalProduction",
      align: "center",
      width: 170,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Last 12 months production",
      dataIndex: "last12MonthsProduction",
      key: "last12MonthsProduction",
      align: "center",
      width: 230,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Gross Commission",
      dataIndex: "totalGrossCommission",
      key: "totalGrossCommission",
      align: "center",
      width: 210,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Agent Commission",
      dataIndex: "totalAgentCommission",
      key: "totalAgentCommission",
      align: "center",
      width: 210,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Total Radius Transaction Revenue",
      dataIndex: "totalRadiusTransactionRevenue",
      key: "totalRadiusTransactionRevenue",
      align: "center",
      sorter: true,
      width: 280,

      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "AR collected from transactions",
      dataIndex: "additionalARCollected",
      key: "additionalARCollected",
      align: "center",
      width: 280,
      // sorter: true,
      // showSorterTooltip: false,
      // sortDirections: ["ascend", "descend"],
      // onHeaderCell: (column) => ({
      //   onClick: () => {
      //     setSortConfig((prevConfig) => {
      //       const isCurrentlySorted = prevConfig.key === column.key;
      //       const newOrder =
      //         isCurrentlySorted && prevConfig.order === "ASC"
      //           ? "DESC"
      //           : prevConfig.order === "DESC"
      //           ? null
      //           : "ASC";
      //       handleSortForAgents(
      //         sortFunctionKeysForAgents(column.key),
      //         newOrder
      //       );
      //       return { key: column.key, order: newOrder };
      //     });
      //   },
      // }),
    },
    {
      title: "Total Accounts Receivable",
      dataIndex: "totalAccountReceivable",
      key: "totalAccountReceivable",
      align: "center",
      width: 250,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Accounts Receivable - manual",
      dataIndex: "accountsReceivableManual",
      key: "accountsReceivableManual",
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      width: 250,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Accounts Receivable - Software Fee",
      dataIndex: "accountsReceivableBroker",
      key: "accountsReceivableBroker",
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      width: 290,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    {
      title: "Accounts Receivable - E&O",
      dataIndex: "accountsReceivableEO",
      key: "accountsReceivableEO",
      align: "center",
      sorter: true,
      showSorterTooltip: false,
      width: 250,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForAgents(
              sortFunctionKeysForAgents(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },

    {
      title: "Total Monthly Subscription",
      dataIndex: "totalMonthlyCost",
      key: "totalMonthlyCost",
      align: "center",
      width: 220,
    },
    {
      title: "Software Fee",
      dataIndex: "brokeragePlans",
      key: "brokeragePlans",
      align: "center",
      width: 250,
    },
    { title: "E&O", dataIndex: "eo", key: "eo", align: "center", width: 250 },
    {
      title: "Add ons",
      dataIndex: "addOns",
      key: "addOns",
      align: "center",
      width: 320,
    },
    // {
    //   title: "Subscription Status - Broker",
    //   dataIndex: "brokerSubscriptionStatus",
    //   key: "brokerSubscriptionStatus",
    //   align: "center",
    //   width: 280,
    // },
    // {
    //   title: "Subscription Status - E&O",
    //   dataIndex: "eoSubscriptionStatus",
    //   key: "eoSubscriptionStatus",
    //   align: "center",
    //   width: 280,
    // },
    {
      title: "Plan Type",
      dataIndex: "planType",
      key: "planType",
      align: "center",
      width: 170,
    },
    {
      title: "Onboarding Status",
      dataIndex: "onboardingStatus",
      key: "onboardingStatus",
      align: "center",
      width: 170,
    },
    {
      title: "License States",
      dataIndex: "licenseStates", 
      key: "licenseStates",
      align: "center",
      width: 240,
      render: (text) => {
        if (!text) return "--";
        return text.split("|").map((state, index) => (
          <div key={index}>{state.trim()}</div>
        ));
      }
    },
    {
      title: "License Numbers",
      dataIndex: "licenseNumbers",
      key: "licenseNumbers",
      align: "center",
      width: 240,
      render: (text) => {
        if (!text) return "--";
        return text.split("|").map((no, index) => (
          <div key={index}>{no.trim()}</div>
        ));
      }
    },
    {
      title: "License Expiry Dates",
      dataIndex: "licenseExpiryDates",
      key: "licenseExpiryDates",
      align: "center",
      width: 240,
      render: (text) => {
        if (!text) return "--";
        return text.split("|").map((expiry, index) => (
          <div key={index}>{expiry.trim()}</div>
        ));
      }
    },
    {
      title: "MLS Names",
      dataIndex: "mls_names",
      key: "mls_names",
      align: "center",
      width: 240,
      render: (text) => {
        if (!text) return "--";
        return text.split("|").map((name, index) => (
          <div key={index}>{name.trim()}</div>
        ));
      }
    },
    {
      title: "Association Names",
      dataIndex: "association_names",
      key: "association_names",
      align: "center",
      width: 270,
      render: (text) => {
        if (!text) return "--";
        return text.split("|").map((name, index) => (
          <div key={index}>{name.trim()}</div>
        ));
      }
    },
    {
      title: "Office Address",
      dataIndex: "officeAddress",
      key: "officeAddress",
      align: "center",
      width: 240,
    },
    {
      title: "Is DBA Signed ?",
      dataIndex: "isDbasigned",
      key: "isDbasigned",
      align: "center",
      width: 240,
      render: (value) => {
        if (value === 1) return "Yes";
        if (value === 0) return "No";
        return value;
      }
    },
    {
      title: "DBA Name",
      dataIndex: "dbaName",
      key: "dbaName",
      align: "center",
      width: 240,
    },
    {
      title: "Is DBA new or previously registered?",
      dataIndex: "newRegistration", 
      key: "newRegistration",
      align: "center",
      width: 240,
      render: (value) => {
        if (value === 1) return "Yes";
        if (value === 0) return "No";
        return value;
      }
    },
    {
      title: "Does business have a corresponding entity, e.g., S corp, LLC, etc.?",
      dataIndex: "correspondingEntity",
      key: "correspondingEntity",
      align: "center", 
      width: 240,
      render: (value) => {
        if (value === 1) return "Yes";
        if (value === 0) return "No";
        return value;
      }
    },
    {
      title: "Does business have its own brand assets and Corp ID/logo?",
      dataIndex: "ownBrandAssets",
      key: "ownBrandAssets",
      align: "center",
      width: 240,
      render: (value) => {
        if (value === 1) return "Yes";
        if (value === 0) return "No";
        return value;
        // return value === 1 ? "Yes" : "No";
      }
    },
    {
      title: "Is DBA Address Same As Office Address ?",
      dataIndex: "isDbaAddressSameAsOfficeAddress",
      key: "isDbaAddressSameAsOfficeAddress", 
      align: "center",
      width: 240,
      render: (value) => {
        if (value === 1) return "Yes";
        if (value === 0) return "No";
        return value;
      }
    },
    {
      title: "DBA Address",
      dataIndex: "dbaAddress",
      key: "dbaAddress",
      align: "center",
      width: 240,
    },
    {
      title: "Subscription Status",
      dataIndex: "subscriptionStatus",
      key: "subscriptionStatus",
      align: "center",
      width: 220,
    },
    {
      title: "Stripe Subscription Status - Software Fee",
      key: "labelledBrokerSubsStatus",
      align: "center",
      width: 300,
      render: (_, item) => {
        const status = getExpiredSubStatus(item.labelledBrokerSubsStatus);
        const formattedDate = getFormattedExpiryDate(
          item.brokerExpiryDate,
          item.labelledBrokerSubsStatus
        );
    
        return (
          <div>
            <div className="block">{status}</div>
            {formattedDate && (
              <div className="text-gray-500 text-xs mt-1 block">
                Expired at: {formattedDate}
              </div>
            )}
          </div>
        );
      }
    },
    
    {
      title: "Stripe Subscription Status - E&O",
      // dataIndex: "labelledEoiSubsStatus",
      key: "labelledEoiSubsStatus",
      align: "center",
      width: 240,
      render: (_, item) => {
        const status = getExpiredSubStatus(item.labelledEoiSubsStatus);
        const formattedDate = getFormattedExpiryDate(
          item.eoiExpiryDate,
          item.labelledEoiSubsStatus
        );
    
        return (
          <div >
            <div>{status}</div>
            {formattedDate && (
              <div className="text-gray-500 text-xs mt-1">
                Expired on: {formattedDate}
              </div>
            )}
          </div>
        );
      }
    },
    {
      title: "1099 link",
      dataIndex: "w9Link",
      key: "w9Link",
      align: "center",
      width: 100,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      width: 160,
    },
  ];

  const allSaasAccountColumns = [
    {
      title: "Account name",
      dataIndex: "accountName",
      key: "accountName",
      align: "center",
      width: 220,
      fixed: 'left',
    },
    {
      title: "Account Type",
      dataIndex: "type",
      key: "type",
      width: 160,
      align: "center",
    },
    {
      title: "Team Size",
      dataIndex: "teamSize",
      key: "teamSize",
      width: 160,
      align: "center",
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      align: "center",
      width: 150,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSaasAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === "createdDate";
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForSaasAccounts(
              sortFunctionKeysForSaasAccounts(column.key),
              newOrder
            );
            return { key: "createdDate", order: newOrder };
          });
        },
      }),
    },
    {
      title: "Subscription Start Date",
      dataIndex: "subsDate",
      key: "subsDate",
      align: "center",
      width: 220,
      sorter: true,
      showSorterTooltip: false,
      sortDirections: ["ascend", "descend"],
      onHeaderCell: (column) => ({
        onClick: () => {
          setSaasAccountsSortConfig((prevConfig) => {
            const isCurrentlySorted = prevConfig.key === column.key;
            const newOrder =
              isCurrentlySorted && prevConfig.order === "ASC"
                ? "DESC"
                : prevConfig.order === "DESC"
                ? null
                : "ASC";
            handleSortForSaasAccounts(
              sortFunctionKeysForSaasAccounts(column.key),
              newOrder
            );
            return { key: column.key, order: newOrder };
          });
        },
      }),
    },
    // {
    //   title: "Churned Date",
    //   dataIndex: "churnedDate",
    //   key: "churnedDate",
    //   align: "center",
    //   width: 160,
    //   sorter: true,
    //   showSorterTooltip: false,
    //   sortDirections: ["ascend", "descend"],
    //   onHeaderCell: (column) => ({
    //     onClick: () => {
    //       setSaasAccountsSortConfig((prevConfig) => {
    //         const isCurrentlySorted = prevConfig.key === column.key;
    //         const newOrder =
    //           isCurrentlySorted && prevConfig.order === "ASC"
    //             ? "DESC"
    //             : prevConfig.order === "DESC"
    //             ? null
    //             : "ASC";
    //         handleSortForSaasAccounts(
    //           sortFunctionKeysForSaasAccounts(column.key),
    //           newOrder
    //         );
    //         return { key: column.key, order: newOrder };
    //       });
    //     },
    //   }),
    // },
    // {
    //   title: "AI Credits Paid",
    //   dataIndex: "aiCreditsPaid",
    //   key: "aiCreditsPaid",
    //   align: "center",
    //   width: 220,
    //   sorter: true,
    //   showSorterTooltip: false,
    //   sortDirections: ["ascend", "descend"],
    //   onHeaderCell: (column) => ({
    //     onClick: () => {
    //       setSaasAccountsSortConfig((prevConfig) => {
    //         const isCurrentlySorted = prevConfig.key === column.key;
    //         const newOrder =
    //           isCurrentlySorted && prevConfig.order === "ASC"
    //             ? "DESC"
    //             : prevConfig.order === "DESC"
    //             ? null
    //             : "ASC";
    //         handleSortForSaasAccounts(
    //           sortFunctionKeysForSaasAccounts(column.key),
    //           newOrder
    //         );
    //         return { key: column.key, order: newOrder };
    //       });
    //     },
    //   }),
    // },
    // {
    //   title: "AI Credits Available",
    //   dataIndex: "aiCreditsAvailable",
    //   key: "aiCreditsAvailable",
    //   align: "center",
    //   width: 220,
    //   sorter: true,
    //   showSorterTooltip: false,
    //   sortDirections: ["ascend", "descend"],
    //   onHeaderCell: (column) => ({
    //     onClick: () => {
    //       setSaasAccountsSortConfig((prevConfig) => {
    //         const isCurrentlySorted = prevConfig.key === column.key;
    //         const newOrder =
    //           isCurrentlySorted && prevConfig.order === "ASC"
    //             ? "DESC"
    //             : prevConfig.order === "DESC"
    //             ? null
    //             : "ASC";
    //         handleSortForSaasAccounts(
    //           sortFunctionKeysForSaasAccounts(column.key),
    //           newOrder
    //         );
    //         return { key: column.key, order: newOrder };
    //       });
    //     },
    //   }),
    // },

    // {
    //   title: "AI Credits Consumed",
    //   dataIndex: "aiCreditsConsumed",
    //   key: "aiCreditsConsumed",
    //   align: "center",
    //   width: 220,
    //   sorter: true,
    //   showSorterTooltip: false,
    //   sortDirections: ["ascend", "descend"],
    //   onHeaderCell: (column) => ({
    //     onClick: () => {
    //       setSaasAccountsSortConfig((prevConfig) => {
    //         const isCurrentlySorted = prevConfig.key === column.key;
    //         const newOrder =
    //           isCurrentlySorted && prevConfig.order === "ASC"
    //             ? "DESC"
    //             : prevConfig.order === "DESC"
    //             ? null
    //             : "ASC";
    //         handleSortForSaasAccounts(
    //           sortFunctionKeysForSaasAccounts(column.key),
    //           newOrder
    //         );
    //         return { key: column.key, order: newOrder };
    //       });
    //     },
    //   }),
    // },
    // {
    //   title: "Client App Logins",
    //   dataIndex: "clientAppLogins",
    //   key: "clientAppLogins",
    //   align: "center",
    //   width: 220,

    //   sorter: true,
    //   showSorterTooltip: false,
    //   sortDirections: ["ascend", "descend"],
    //   onHeaderCell: (column) => ({
    //     onClick: () => {
    //       setSaasAccountsSortConfig((prevConfig) => {
    //         const isCurrentlySorted = prevConfig.key === column.key;
    //         const newOrder =
    //           isCurrentlySorted && prevConfig.order === "ASC"
    //             ? "DESC"
    //             : prevConfig.order === "DESC"
    //             ? null
    //             : "ASC";
    //         handleSortForSaasAccounts(
    //           sortFunctionKeysForSaasAccounts(column.key),
    //           newOrder
    //         );
    //         return { key: column.key, order: newOrder };
    //       });
    //     },
    //   }),
    // },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   key: "actions",
    //   align: "center",
    //   width: 160,
    // }
  ];

  const formatTeamSizeLabel = (key) => {
    const labels = {
      lessThan10: "< 10",
      greaterThan10: "10 +",
      greaterThan20: "20 +",
      greaterThan50: "50 +",
      All: "All",
    };

    return labels[key] || "";
  };

  // const next = () => {
  //   console.log('Skip before increment:', skip);
  //   setSkip(prevSkip => prevSkip + limit); // Increment the skip
  //   console.log('Skip after increment:', skip + limit); // This will show the incremented skip
  // };

  const filteredAgentColumns = allAgentColumns.filter((column) => {
    if (
      column.key === "listingsActive" ||
      column.key === "brokerageDate" ||
      column.key === "additionalARCollected" ||
      column.key === "totalAccountReceivable" ||
      column.key === "accountsReceivableManual" ||
      column.key === "accountsReceivableBroker" ||
      column.key === "accountsReceivableEO" ||
      column.key === "totalMonthlyCost" ||
      column.key === "brokeragePlans" ||
      column.key === "addOns" ||
      column.key === "subscriptionStatus" ||
      column.key === "w9Link" ||
      column.key === "actions" ||
      column.key === "eo"
    ) {
      return !showChurnedAgents;
    }
    if (column.key === "churnedDate") return showChurnedAgents;

    return true;
  });

  const filteredAccountColumns = allAccountColumns.filter((column) => {
    if (column.key === "churnedDate") return showChurnedAccounts;

    return true;
  });

  function agentType(agent) {
    if (agent === "individual_agent") return "Individual Agent";
    if (agent === "associate") return "Associate";
    if (agent === "admin") return "Team Lead";
    if (agent === "co_team_lead") return "Co Team Lead";
    if (agent === "team_tc") return "Individual Agent";
    if (agent === "assistant") return "Assistant";
    if (agent === "All") return "All";
  }
  const displayValue = (value) => {
    if (value === 0 || value === "0" || value === null || value === undefined) {
      return "--";
    }

    const num = Number(value);
    if (isNaN(num)) return "--";

    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    return `$${formatter.format(num)}`;
  };
  const displayValueForString = (value) => {
    return value === 0 || value === "0" || value === null || value === undefined
      ? "--"
      : value;
  };
  const transformedAgentData =
    agentData?.result?.map((item, index) => ({
      key: item.id || index,
      agentName: (
        <Link to={`/broker/dashboard/${item.id}/subscription`}>
          {`${item.firstname} ${item.lastname}` || "--"}
        </Link>
      ),

      agentEmail: item.email || "--",
      accountName: item.team_name || "--",
      role: agentType(item.agent_type),
      createdDate: formatDate(item.created_at) || "--",
      brokerageDate:
        formatDate(item.updated_ica_signed_date) ||
        formatDate(item.ica_signed_date) ||
        formatDate(item.ica_signed_date) ||
        "--",
      churnedDate: formatDate(item.churned_date) || "--",
      dealsClosed: displayValueForString(item.deals_closed),
      dealsInContract: displayValueForString(item.deals_in_contract),
      listingsActive: displayValueForString(item.active_listings),
      commissionSplit: displayValueForString(item.split || "--"),
      accountsReceivableBroker: displayValue(item.accounts_receivable_broker),
      accountsReceivableManual: displayValue(item.accounts_receivable_manual),
      totalAccountReceivable: displayValue(
        item?.accounts_receivable_broker +
          item.accounts_receivable_eoi +
          item?.accounts_receivable_manual -
          item.additional_ar_collected
      ),
      accountsReceivableEO: displayValue(item.accounts_receivable_eoi),
      additionalARCollected: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div>{displayValue(item.additional_ar_collected)}</div>

          {editingRowId === item.id ? (
            <input
              type={"number"}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const newValue =
                    (parseFloat(item.additional_ar_collected) || 0) +
                    (parseFloat(inputValue) || 0);
                  updateAdditionalArCollected({
                    agentId: item.id,
                    value: inputValue,
                  });
                  item.additional_ar_collected = newValue;
                  setEditingRowId(null);
                }
              }}
              autoFocus
              className="border px-2 py-1 rounded w-24"
            />
          ) : (
            <button
              onClick={() => {
                setEditingRowId(item.id);
                setInputValue(item.additional_ar_collected || "");
              }}
              style={{
                color: "#1E90FF",
                background: "none",
                border: "none",
                padding: "0",
                cursor: "pointer",
              }}
            >
              {item.additional_ar_collected == "0" ? "Add Amount" : "Edit"}
            </button>
          )}
        </div>
      ),
      cap: displayValue(item.cap),
      addOns: (() => {
        try {
          const input = item.subscribed_add_ons;
          const parsedAddOns = input.split("|").map((part) => part.trim());

          let totalSum = 0;
          const addOnElements = parsedAddOns
            .map((addons, idx) => {
              const [name, value, billingCycle] = addons.split(":");
              const num = parseFloat(value);
              if (!isNaN(num) && billingCycle === "MONTHLY") {
                totalSum += num;
              }

              return (
                <div key={idx}>{`${name} - $${value} / ${billingCycle
                  .slice(0, -2)
                  .toLowerCase()}`}</div>
              );
            })
            .filter(Boolean);

          if (addOnElements.length > 0) {
            addOnElements.push(
              <div key="total">
                <strong>{`$${totalSum} per month`}</strong>
              </div>
            );
          }

          return addOnElements.length > 0 ? addOnElements : "--"; // Return "--" if empty
        } catch (error) {
          return "--";
        }
      })(),
      brokeragePlans: (() => {
        try {
          const input = item.brokerage_plan;
          const parts = input.split("|").map((part) => part.trim());
          const result = parts.map((entry) => {
            const [value, billingCycle] = entry.split(":");
            return (
              <div>{`$${value} per ${billingCycle
                .slice(0, -2)
                .toLowerCase()}`}</div>
            );
          });
          return result;
        } catch (error) {
          return "--";
        }
      })(),

      eo: (() => {
        try {
          const input = item.eo;
          const parts = input.split("|").map((part) => part.trim());
          const result = parts.map((entry) => {
            const [value, billingCycle] = entry.split(":");
            return (
              <div>{`$${value} per ${billingCycle
                .slice(0, -2)
                .toLowerCase()}`}</div>
            );
          });
          return result;
        } catch (error) {
          return "--";
        }
      })(),
      totalMonthlyCost: (() => {
        try {
          const input = item.subscribed_add_ons || "";
          const parsedAddOns = input.split("|").map((part) => part.trim());

          let totalAddonSum = 0;
          parsedAddOns.forEach((addon) => {
            const [name, value, billingCycle] = addon.split(":");
            const num = parseFloat(value);
            if (!isNaN(num) && billingCycle === "MONTHLY") {
              totalAddonSum += num;
            }
          });

          const brokerageInput = item.brokerage_plan || "";
          const parts = brokerageInput.split("|").map((part) => part.trim());

          let totalBrokerageSum = 0;
          parts.forEach((entry) => {
            const [value, billingCycle] = entry.split(":");
            const num = parseFloat(value);
            if (!isNaN(num) && billingCycle === "MONTHLY") {
              totalBrokerageSum += num;
            }
          });

          const eoInput = item.eo || "";
          const eoparts = eoInput.split("|").map((part) => part.trim());

          let totalEOSum = 0;
          eoparts.forEach((entry) => {
            const [value, billingCycle] = entry.split(":");
            const num = parseFloat(value);
            if (!isNaN(num) && billingCycle === "MONTHLY") {
              totalEOSum += num;
            }
          });

          return `$${totalAddonSum + totalBrokerageSum + totalEOSum || "0"}`;
        } catch (error) {
          return "--";
        }
      })(),
      totalProduction: displayValue(item.total_production),
      firstDealClosed: formatDate(item.first_closed_deal) || "--",
      firstDealSubmitted: formatDate(item.first_submitted_deal) || "--",
      last12MonthsProduction: displayValue(item.last_12_months_production),
      planType: item.paid_by || "--",
      onboardingStatus: item.onboarding_status || "--",
      totalGrossCommission: displayValue(item.total_gross_commission),
      totalAgentCommission: displayValue(item.total_agent_commission),
      totalRadiusTransactionRevenue: displayValue(item.total_radius_fees),
      // brokerSubscriptionStatus: item.broker_subscription_status || "--",
      // eoSubscriptionStatus: item.eo_subscription_status || "--",
      // w9Link: item.wd_url || "--",
      brokerSubsStatus: item.broker_subscription_status || "--",
      eoiSubsStatus: item.eoi_subscription_status || "--",
      // labelledBrokerSubsStatus: (
      //   <div className="flex flex-col text-sm leading-tight">
      //     <div>{getExpiredSubStatus(item.broker_subscription_status)}</div>
      //     {getFormattedExpiryDate(item.broker_subscription_expiry_date,item.broker_subscription_status) && (
      //        <div className="text-gray-500 text-xs mt-1">
      //         Exp: {getFormattedExpiryDate(item.broker_subscription_expiry_date,item.broker_subscription_status)}
      //       </div>
      //     )}
      //   </div>
      // ),
      
      // labelledEoiSubsStatus: (() => {
      //   const formattedDate = getFormattedExpiryDate(
      //     item.eoi_subscription_expiry_date,
      //     item.eoi_subscription_status
      //   );
      
      //   return (
      //     <div className="flex flex-col text-sm leading-tight whitespace-normal">
      //       <div>{getExpiredSubStatus(item.eoi_subscription_status)}</div>
      //       {formattedDate && (
      //         <div className="text-gray-500 text-xs mt-1">
      //           Exp: {formattedDate}
      //         </div>
      //       )}
      //     </div>
      //   );
      // })(),
      
      labelledBrokerSubsStatus:item.broker_subscription_status,
      brokerExpiryDate:item.broker_subscription_expiry_date,
      labelledEoiSubsStatus:item.eoi_subscription_status,
      eoiExpiryDate:item.eoi_subscription_expiry_date,
      licenseStates: item.license_states || "--",
      licenseNumbers: item.license_numbers || "--", 
      licenseExpiryDates: item.license_expiry_dates ? item.license_expiry_dates.split("|").map(date => formatDate(date.trim())).join(" | ") : "--",
      mls_names: item.mls_names || "--",
      association_names: item.association_names || "--",
      officeAddress: item.office_address || "--",
      isDbasigned: item.is_dba_signed || "--",
      dbaName: item.dba_name || "--",
      newRegistration: item.new_registration || "--",
      correspondingEntity: item.corresponding_entity || "--",
      ownBrandAssets: item.own_brand_assets || "--",
      isDbaAddressSameAsOfficeAddress: item.is_dba_address_same_as_office_address || "--",
      dbaAddress: item.dba_address || "--",
      subscriptionStatus: (() => {
        if (!item.broker_subscription_status || !item.eoi_subscription_status) {
          return "Payment failed";
        }

        return getSubStatus(item.broker_subscription_status) ===
          "Payment failed" ||
          getSubStatus(item.eoi_subscription_status) === "Payment failed" ? (
          <p>Payment failed</p>
        ) : (
          <p>Paid</p>
        );
      })(),
      w9Link: item.wd_url ? (
        <>
          <a href={item.wd_url} target="_blank">
            Link
          </a>
          <div>
            Uploaded on {new Date(item.wd_updated).toLocaleDateString()}
          </div>
        </>
      ) : (
        "--"
      ),
      actions: (
        <Dropdown overlay={menu(item)} trigger={["click"]}>
          <button className="p-2 hover:bg-white-100 rounded">
            <MoreOutlined />
          </button>
        </Dropdown>
      ),
    })) || [];

  const handleSearchType = (value) => {
    setSearchByClient(value);
    rosterFetchAgentSearch({ search: value });
  };

  const transformedAccountData =
    accountData?.result?.map((item, index) => ({
      key: item.id || index,
      accountName: (
        <>
          <p>{item.name || `${item.firstname} ${item.lastname}`}</p>
          {item?.type == "Individual Agent" && (
            <Link to={`/broker/dashboard/${item.id}/subscription`}>
              View Agent
            </Link>
          )}
          {item?.type == "Team" && (
            <Link to={`/broker/teams/edit/${item.id}`}>View Team</Link>
          )}
        </>
      ),
      teamSize: item.team_size || "1",
      createdDate: formatDate(item?.created_at) || "--",
      brokerageDate:
        formatDate(item.updated_ica_signed_date) ||
        formatDate(item.ica_signed_date) ||
        "--",
      churnedDate: formatDate(item.churned_date) || "--",
      commissionSplit: item.commission_split || "--",
      dealsClosed: displayValueForString(item.deals_closed),
      type: item.type || "--",
      dealsInContract: displayValueForString(item.total_in_contracts),
      listingsActive: displayValueForString(item.active_listings),
      totalProduction: displayValue(item.total_production),
      last12MonthsProduction: displayValue(item.last_12_months_production),
      totalGrossCommission: displayValue(item.total_gross_commission),
      totalAgentCommission: displayValue(item.total_agent_commission),
      totalRadiusTransactionRevenue: displayValue(item.total_radius_fees),
    })) || [];

  const transformedSaasData =
    saasUsersData?.result?.map((item, index) => ({
      key: item.user_id || index,
      // accountName: item.name,
      accountName: (
        <>
          <p>{item.name}</p>
          {item?.type == "individual_agent" && (
            <Link to={`/broker/dashboard/${item.user_id}/subscription`}>
              View Agent
            </Link>
          )}
          {item?.type == "team" && (
            <Link to={`/broker/teams/edit/${item.team_id}`}>View Team</Link>
          )}
        </>
      ),
      teamSize: item.team_size,
      createdDate: formatDate(item?.created_at) || "--",
      subsDate: formatDate(item?.subs_start_date) || "--",
      churnedDate: formatDate(item?.churned_at) || "--",
      // clientAppLogins: displayValueForString(item?.client_app_logins),
      aiCreditsPaid: "--",
      aiCreditsAvailable: "--",
      aiCreditsConsumed: "--",
      type: formatRoleDropdown(item.type) || "--",
      actions: (
        <Dropdown overlay={saasMenu(item)} trigger={["click"]}>
          <button className="p-2 hover:bg-white-100 rounded">
            <MoreOutlined />
          </button>
        </Dropdown>
      ),
    })) || [];

  useEffect(() => {
    fetchData();
  }, [skip, agentSkip, accountSkip, saasSkip,limit]);

  const getPaginationValues = () => {
    switch (activeTab) {
      case "1":
        return {
          skip: accountSkip,
          setSkip: setAccountSkip,
          totalCount: totalAccountCount,
        };
      case "2":
        return {
          skip: agentSkip,
          setSkip: setAgentSkip,
          totalCount: totalAgentCount,
        };
      case "3":
        return {
          skip: saasSkip,
          setSkip: setSaasSkip,
          totalCount: totalSaasCount,
        };
      default:
        return { skip: 0, setSkip: () => {}, totalCount: 0 };
    }
  };

  const { skip, setSkip, totalCount } = getPaginationValues();

  const fetchData = () => {
    const pagination = { limit, skip };

    if (activeTab === "1") {
      const payload = {
        ...createPayloadForAccounts(),
        limit,
        skip,
      };

      if (sortAccountsConfig.key && sortAccountsConfig.order) {
        payload.sortBy = `${sortAccountsConfig.key}=${sortAccountsConfig.order}`;
      }

      if (sortAccountsConfig.key && sortAccountsConfig.order) {
        payload.sortBy = `${sortAccountsConfig.key}=${sortAccountsConfig.order}`;
      }
      getAllAccountsForRosterPage(payload);
    } else if (activeTab === "2") {
      const payload = {
        ...createPayloadForAgents(),
        limit,
        skip,
      };
      if (sortConfig.key && sortConfig.order) {
        payload.sortBy = `${sortConfig.key}=${sortConfig.order}`;
      }
      getAllAgentsForRosterPage(payload);
    } else if (activeTab === "3") {
      const payload = {
        ...createPayloadForSaasAccounts(),
        limit,
        skip,
      };
      if (sortSaasAccountsConfig.key && sortSaasAccountsConfig.order) {
        payload.sortBy = `${sortSaasAccountsConfig.key}=${sortSaasAccountsConfig.order}`;
      }
      getSaasAccountsForRosterPage(payload);
    }
  };

  return (
    <div>
      {activeTab === "1" && (
        <NewRoster overview={accountData?.overview} activeTab={activeTab} />
      )}
      {activeTab === "2" && (
        <NewRoster overview={agentData?.overview} activeTab={activeTab} />
      )}
      {activeTab === "3" && (
        <NewRoster overview={saasUsersData?.overview} activeTab={activeTab} />
      )}
      {loaderActive && <Loader />}
      <OuterWrap>
        <StyledTabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={handleChangeTab}
        >
          <TabPane
            tab={
              <span>
                <AppstoreOutlined /> Brokerage accounts
              </span>
            }
            key="1"
          ></TabPane>
          filter by
          <TabPane
            tab={
              <span>
                <AppstoreOutlined /> Brokerage agents
              </span>
            }
            key="2"
          ></TabPane>
          <TabPane
            tab={
              <span>
                <AppstoreOutlined /> Saas subscribed agents
              </span>
            }
            key="3"
          ></TabPane>
        </StyledTabs>
        <BorderWrap>
          <FilterWrap>
            {activeTab === "1" && (
              <p style={{ fontSize: "28px", fontWeight: "700" }}>
                All accounts dashboard
              </p>
            )}
            {activeTab === "2" && (
              <p style={{ fontSize: "28px", fontWeight: "700" }}>
                All agents dashboard
              </p>
            )}
            {activeTab === "3" && (
              <p style={{ fontSize: "28px", fontWeight: "700" }}>
                Saas users dashboard
              </p>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "12px",
              }}
            >
              <>
                {activeTab === "2" && (
                  <InputWrapper>
                    <div ref={inputWrapperRef}>
                    <StyledInput
                      list="agent-list"
                      placeholder="Search by client"
                      prefix={<SearchOutlined />}
                      width="100%"
                      value={searchByClient}
                      // onChange={(e) => setSearchByClient(e.target.value)}
                      onChange={(e) => {
                        toggleAgentList(true);
                        handleSearchType(e.target.value);
                      }}
                    />

                    <AgentList
                      hideDropdown={!isAgentListDropdownVisible}
                      hasAgents={agentsLists && agentsLists.length > 0}
                    >
                      {isFetchingName ? (
                        <Loader width="25px" top={0} bottom={0} />
                      ) : (
                        <React.Fragment>
                          {searchByClient &&
                            agentsLists &&
                            agentsLists.length > 0 &&
                            agentsLists.map((agent) => (
                              <AgentItem
                                key={agent.id}
                                onClick={() => {
                                  setSearchByClient(agent.email);
                                  // getAllAgentsForRosterPage({
                                  //   ...createPayload(),
                                  //   agentEmail: agent.email,
                                  //   skip: 0,
                                  //   limit: 1,
                                  //   churnedFilter: (churnedAgentCheck == true ? 1 : 0),
                                  // })
                                  toggleAgentList(false);
                                  setSearch(!search);
                                }}
                              >
                                <div>
                                  <img src={agent.agent_image} alt="" />
                                </div>
                                <div>
                                  <p>
                                    {`${agent.firstname} ${agent.lastname}`}
                                  </p>
                                  <h6>{agent.email}</h6>
                                  <NumberFormat
                                    format="+1 (###) ###-####"
                                    mask="_"
                                    value={agent.phone}
                                  />
                                </div>
                              </AgentItem>
                            ))}
                        </React.Fragment>
                      )}
                    </AgentList>
                    </div>
                    </InputWrapper>
                )}

                {/* {searchByClient && data?.result?.length > 0 && (
              <SuggestionsList>
                {data?.result?.map((agent) => (
                  <SuggestionItem key={agent.id} onClick={{}}>
                    <Avatar
                      src={agent.avatar || "default-avatar.png"}
                      alt={agent.name}
                    />
                    <AgentDetails>
                      <AgentName>{agent.name}</AgentName>
                      <AgentEmail>{agent.email}</AgentEmail>
                    </AgentDetails>
                  </SuggestionItem>
                ))}
              </SuggestionsList>
            )} */}

                {activeTab === "2" && (
                  <StyledInput
                    placeholder="Search by Account"
                    onChange={(e) => {
                      handlesearchByAccount(e.target.value);
                    }}
                    value={searchByAccount}
                    prefix={<SearchOutlined />}
                    width={!showChurnedAgents ? "24.6%" : "43%"}
                  />
                )}
                {activeTab === "1" && (
                  <StyledInput
                    placeholder="Search by Account"
                    onChange={(e) => {
                      handlesearchByAccount(e.target.value);
                    }}
                    value={searchByAccount}
                    prefix={<SearchOutlined />}
                    width="42%"
                  />
                )}
                {activeTab === "3" && (
                  <StyledInput
                    placeholder="Search by Account"
                    onChange={(e) => {
                      handlesearchByAccount(e.target.value);
                    }}
                    value={searchByAccount}
                    prefix={<SearchOutlined />}
                    width="72%"
                  />
                )}
                {activeTab === "2" && !showChurnedAgents && (
                  <Dropdown overlay={subsStatusItems} trigger={["click"]}>
                    <SearchDropdownContainer width="27.4%">
                      <span>
                        {selectedStatus || "Select Subscription Status"}
                      </span>
                      <DownOutlined />
                    </SearchDropdownContainer>
                  </Dropdown>
                )}
                {activeTab === "2" && (
                  <Dropdown overlay={roleitems} trigger={["click"]}>
                    <SearchDropdownContainer width="18.4%">
                      <span>
                        {formatRoleDropdown(selectedRole) || "Select Role"}
                      </span>
                      <DownOutlined />
                    </SearchDropdownContainer>
                  </Dropdown>
                )}
                {activeTab === "1" && (
                  <Dropdown overlay={teamSizeOptions} trigger={["click"]}>
                    <SearchDropdownContainer width="29.4%">
                      <span>
                        {formatTeamSizeLabel(selectedTeamsize) || "Team Size"}
                      </span>
                      <DownOutlined />
                    </SearchDropdownContainer>
                  </Dropdown>
                )}
                {activeTab === "1" && (
                  <Dropdown
                    overlay={accountTypeBrokerItems}
                    trigger={["click"]}
                  >
                    <SearchDropdownContainer width="25%">
                      <span>{selectedBrokerAccountType || "Account Type"}</span>
                      <DownOutlined />
                    </SearchDropdownContainer>
                  </Dropdown>
                )}
                {activeTab === "3" && (
                  <Dropdown overlay={accountTypeSaasItems} trigger={["click"]}>
                    <SearchDropdownContainer width="25%">
                      <span>
                        {accountTypeLabel(selectedSaasAccountType) ||
                          "Account Type"}
                      </span>
                      <DownOutlined />
                    </SearchDropdownContainer>
                  </Dropdown>
                )}
              </>

              {/* <SearchDropdownContainer
          width="8.8%"
          onClick={() => setSeeFilters((prev) => !prev)}
        >
          <span>Filters</span>
          <DownOutlined />
        </SearchDropdownContainer> */}

              <>
                {(activeTab === "1" || activeTab === "3") && (
                  <>
                    <InputGroup width={activeTab === "3" ? "50%" : "35%"}>
                      <Label>
                        {activeTab === "3"
                          ? "Subscription Start Date"
                          : "Brokerage Join Date"}
                      </Label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                        }}
                      >
                        <DatePickerContainer
                          width={activeTab === "3" ? "47%" : "47%"}
                        >
                          <StyledDatePicker
                            format="DD / MM / YYYY"
                            placeholder="From"
                            value={brokerageJoinDate[0]}
                            onChange={(date) =>
                              setBrokerageJoinDate([date, brokerageJoinDate[1]])
                            }
                          />
                        </DatePickerContainer>
                        <DatePickerContainer
                          width={activeTab === "3" ? "47%" : "47%"}
                        >
                          <StyledDatePicker
                            format="DD / MM / YYYY"
                            placeholder="To"
                            value={brokerageJoinDate[1]}
                            onChange={(date) =>
                              setBrokerageJoinDate([brokerageJoinDate[0], date])
                            }
                          />
                        </DatePickerContainer>
                      </div>
                    </InputGroup>
                    <InputGroup width={activeTab === "3" ? "49%" : "37%"}>
                      <Label>{"Create Date"}</Label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                        }}
                      >
                        <DatePickerContainer
                          width={activeTab === "3" ? "47%" : "47%"}
                        >
                          <StyledDatePicker
                            format="DD / MM / YYYY"
                            placeholder="From"
                            value={createdDate[0]}
                            onChange={(date) =>
                              setCreatedDate([date, createdDate[1]])
                            }
                          />
                        </DatePickerContainer>
                        <DatePickerContainer
                          width={activeTab === "3" ? "47%" : "47%"}
                        >
                          <StyledDatePicker
                            format="DD / MM / YYYY"
                            placeholder="To"
                            value={createdDate[1]}
                            onChange={(date) =>
                              setCreatedDate([createdDate[0], date])
                            }
                          />
                        </DatePickerContainer>
                      </div>
                    </InputGroup>
                    {/* <InputGroup width={activeTab === "3" ? "32%" : "24%"}>
            <Label>{"Churned Date"}</Label>
            <div style={{display:"flex",flexDirection:"row",gap:"10px"}}>
            <DatePickerContainer width={activeTab === "3" ? "47%" : "47%"}>
             

             <StyledDatePicker
                format="DD / MM / YYYY"
                placeholder="From"
                value={churnedDate[0]}
                onChange={(date) => setChurnedDate([date, churnedDate[1]])}
              />
            </DatePickerContainer>
            <DatePickerContainer width={activeTab === "3" ? "47%" : "47%"}>

              <StyledDatePicker
                format="DD / MM / YYYY"
                placeholder="To"
                value={churnedDate[1]}
                onChange={(date) => setChurnedDate([churnedDate[0],date])}
              />
            </DatePickerContainer>
            </div>
            </InputGroup> */}
                  </>
                )}
                {activeTab === "2" && (
                  <>
                    {!showChurnedAgents ? (
                      <InputGroup width={"36%"}>
                        <Label>{"Brokerage Join Date"}</Label>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <DatePickerContainer
                            width={activeTab === "3" ? "47%" : "47%"}
                          >
                            <StyledDatePicker
                              format="DD / MM / YYYY"
                              placeholder="From"
                              value={brokerageJoinDate[0]}
                              onChange={(date) =>
                                setBrokerageJoinDate([
                                  date,
                                  brokerageJoinDate[1],
                                ])
                              }
                            />
                          </DatePickerContainer>
                          <DatePickerContainer
                            width={activeTab === "3" ? "47%" : "47%"}
                          >
                            <StyledDatePicker
                              format="DD / MM / YYYY"
                              placeholder="To"
                              value={brokerageJoinDate[1]}
                              onChange={(date) =>
                                setBrokerageJoinDate([
                                  brokerageJoinDate[0],
                                  date,
                                ])
                              }
                            />
                          </DatePickerContainer>
                        </div>
                      </InputGroup>
                    ) : (
                      <></>
                    )}
                    <InputGroup width={"36%"}>
                      <Label>{"Create Date"}</Label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                        }}
                      >
                        <DatePickerContainer
                          width={activeTab === "3" ? "47%" : "47%"}
                        >
                          <StyledDatePicker
                            format="DD / MM / YYYY"
                            placeholder="From"
                            value={createdDate[0]}
                            onChange={(date) =>
                              setCreatedDate([date, createdDate[1]])
                            }
                          />
                        </DatePickerContainer>
                        <DatePickerContainer
                          width={activeTab === "3" ? "47%" : "47%"}
                        >
                          <StyledDatePicker
                            format="DD / MM / YYYY"
                            placeholder="To"
                            value={createdDate[1]}
                            onChange={(date) =>
                              setCreatedDate([createdDate[0], date])
                            }
                          />
                        </DatePickerContainer>
                      </div>
                    </InputGroup>
                    {showChurnedAgents ? (
                      <InputGroup width={"36%"}>
                        <Label>{"Churned Date"}</Label>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <DatePickerContainer
                            width={activeTab === "3" ? "47%" : "47%"}
                          >
                            <StyledDatePicker
                              format="DD / MM / YYYY"
                              placeholder="From"
                              value={churnedDate[0]}
                              onChange={(date) =>
                                setChurnedDate([date, churnedDate[1]])
                              }
                            />
                          </DatePickerContainer>
                          <DatePickerContainer
                            width={activeTab === "3" ? "47%" : "47%"}
                          >
                            <StyledDatePicker
                              format="DD / MM / YYYY"
                              placeholder="To"
                              value={churnedDate[1]}
                              onChange={(date) =>
                                setChurnedDate([churnedDate[0], date])
                              }
                            />
                          </DatePickerContainer>
                        </div>
                      </InputGroup>
                    ) : (
                      <></>
                    )}
                  </>
                )}

                {activeTab !== "3" && (
                  <InputGroup width="25%">
                    <Label>Commission Split</Label>
                    <Dropdown
                      overlay={splitItems}
                      trigger={["click"]}
                      style={{ marginTop: "30px" }}
                    >
                      <SearchDropdownContainer width="100%">
                        <span>{selectedSplit || "Select"}</span>
                        <DownOutlined />
                      </SearchDropdownContainer>
                    </Dropdown>
                  </InputGroup>
                )}
                {/* {activeTab === "2" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "24.5%",
                  gap: "6px",
                }}
              >
                <Label>Cap</Label>
                <Dropdown overlay={capItems} trigger={["click"]}>
                  <SearchDropdownContainer width="100%">
                    <span>{capRange || "Select Cap Range"}</span>
                    <DownOutlined />
                  </SearchDropdownContainer>
                </Dropdown>
              </div>
            )} */}
                {activeTab !== "3" && (
                  <InputGroup width="24%">
                    <Label>Deals closed</Label>
                    <InputRow>
                      <StyledInput
                        placeholder="Min"
                        prefix={<SearchOutlined />}
                        value={dealsClosedRange[0]}
                        onChange={(e) =>
                          setDealsClosedRange([
                            e.target.value,
                            dealsClosedRange[1],
                          ])
                        }
                      />

                      <StyledInput
                        placeholder="Max"
                        value={dealsClosedRange[1]}
                        prefix={<SearchOutlined />}
                        onChange={(e) =>
                          setDealsClosedRange([
                            dealsClosedRange[0],
                            e.target.value,
                          ])
                        }
                      />
                    </InputRow>
                  </InputGroup>
                )}
                {activeTab !== "3" && (
                  <InputGroup width="24%">
                    <Label>Total Transaction Revenue</Label>
                    <InputRow>
                      <StyledCurrencyInput
                        placeholder="Min"
                        value={transactionRevenueRange[0]}
                        onChange={(e) =>
                          setTransactionRevenueRange([
                            e.target.value,
                            transactionRevenueRange[1],
                          ])
                        }
                        prefix="$"
                      />
                      <StyledCurrencyInput
                        placeholder="Max"
                        value={transactionRevenueRange[1]}
                        onChange={(e) =>
                          setTransactionRevenueRange([
                            transactionRevenueRange[0],
                            e.target.value,
                          ])
                        }
                        prefix="$"
                      />
                    </InputRow>
                  </InputGroup>
                )}
                {activeTab !== "3" && (
                  <InputGroup width="24%">
                    <Label>Total Production</Label>
                    <InputRow>
                      <StyledCurrencyInput
                        placeholder="Min"
                        prefix="$"
                        value={minTotalProductionRange}
                        onChange={(e) => {
                          setMinTotalProductionRange(e.target.value);
                        }}
                      />

                      <StyledCurrencyInput
                        placeholder="Max"
                        prefix="$"
                        value={maxTotalProductionRange}
                        onChange={(e) => {
                          setMaxTotalProductionRange(e.target.value);
                        }}
                      />
                    </InputRow>
                  </InputGroup>
                )}
                {activeTab !== "3" && (
                  <InputGroup width="24.5%">
                    <Label>Last 12 months production</Label>
                    <InputRow>
                      <StyledCurrencyInput
                        placeholder="Min"
                        prefix="$"
                        value={last12MonthsProductionRange[0]}
                        onChange={(e) =>
                          setLast12MonthsProductionRange([
                            e.target.value,
                            last12MonthsProductionRange[1],
                          ])
                        }
                      />
                      <StyledCurrencyInput
                        placeholder="Max"
                        prefix="$"
                        value={last12MonthsProductionRange[1]}
                        onChange={(e) =>
                          setLast12MonthsProductionRange([
                            last12MonthsProductionRange[0],
                            e.target.value,
                          ])
                        }
                      />
                    </InputRow>
                  </InputGroup>
                )}

                {/* {activeTab === "3" && (
              <InputGroup width="32%">
                <Label>AI Credits Paid</Label>
                <InputRow>
                  <StyledCurrencyInput
                    placeholder="Min"
                    prefix="$"
                    value={creditPaid[0]}
                    onChange={(e) =>
                      setCreditsPaid([e.target.value, creditPaid[1]])
                    }
                  />
                  <StyledCurrencyInput
                    placeholder="Max"
                    prefix="$"
                    value={creditPaid[1]}
                    onChange={(e) =>
                      setCreditsPaid([creditPaid[0], e.target.value])
                    }
                  />
                </InputRow>
              </InputGroup>
            )}
            {activeTab === "3" && (
              <InputGroup width="32%">
                <Label>AI Credits Available</Label>
                <InputRow>
                  <StyledCurrencyInput
                    placeholder="Min"
                    prefix="$"
                    value={creditAvailable[0]}
                    onChange={(e) =>
                      setCreditsAvailable([e.target.value, creditAvailable[1]])
                    }
                  />
                  <StyledCurrencyInput
                    placeholder="Max"
                    prefix="$"
                    value={creditAvailable[1]}
                    onChange={(e) => 
                      setCreditsAvailable([creditAvailable[0], e.target.value])
                    }
                  />
                </InputRow>
              </InputGroup>
            )}
            {activeTab === "3" && (
              <InputGroup width="33%">
                <Label>AI Credits Consumed</Label>
                <InputRow>
                  <StyledCurrencyInput
                    placeholder="Min"
                    prefix="$"
                    value={creditConsumed[0]}
                    onChange={(e) =>
                      setCreditsConsumed([e.target.value, creditConsumed[1]])
                    }
                  />
                  <StyledCurrencyInput
                    placeholder="Max"
                    prefix="$"
                    value={creditConsumed[1]}
                    onChange={(e) =>
                      setCreditsConsumed([creditConsumed[0], e.target.value])
                    }
                  />
                </InputRow>
              </InputGroup> */}
                {/* )} */}
              </>
            </div>
            <ButtonContainer>
              {activeTab === "1" && (
                <Button
                  type="primary"
                  size={"large"}
                  style={{
                    border: "1px solid #6366F1",
                    borderRadius: "8px",
                    color: "white",
                    backgroundColor: "#6366F1",
                  }}
                  onClick={() => setShowChurnedAccounts((prev) => !prev)}
                >
                  {!showChurnedAccounts
                    ? "Show Churned Accounts"
                    : "Show Active Accounts"}
                </Button>
              )}

              {activeTab === "2" && (
                <Button
                  type="primary"
                  size={"large"}
                  style={{
                    border: "1px solid #6366F1",
                    borderRadius: "8px",
                    color: "white",
                    backgroundColor: "#6366F1",
                  }}
                  onClick={() => setShowChurnedAgents((prev) => !prev)}
                >
                  {!showChurnedAgents
                    ? "Show Churned Agents"
                    : "Show Active Agents"}
                </Button>
              )}
              <Button
                type="primary"
                size={"large"}
                style={{
                  border: "1px solid #6366F1",
                  borderRadius: "8px",
                  color: "white",
                  backgroundColor: "#6366F1",
                }}
                onClick={() => setSearch((prev) => !prev)}
              >
                Apply Filters
              </Button>
              <Button
                size={"large"}
                style={{
                  border: "1px solid red",
                  borderRadius: "8px",
                  color: "red",
                }}
                onClick={handleClearFilter}
              >
                Clear Filters
              </Button>
              <Button
                size={"large"}
                style={{ border: "1px solid #E5E7EB", borderRadius: "8px" }}
                onClick={handleDownload}
              >
                Export to CSV
              </Button>
            </ButtonContainer>
            <Divider
              type="horizontal"
              style={{ padding: "0px", marginTop: "0px" }}
            />

            {activeTab === "2" &&
              (isFetchingAgentData ? (
                <Loader />
              ) : (
                <StyledTableWrapper>
                  <Table
                    columns={filteredAgentColumns}
                    dataSource={transformedAgentData}
                    pagination={false}
                    bordered
                    scroll={{ x: "max-content", y: "60vh" }}
                    sticky={{ offsetHeader: 0 }}
                  />
                </StyledTableWrapper>
              ))}

            {activeTab === "1" &&
              (isFetchingAccounts ? (
                <Loader />
              ) : (
                <StyledTableWrapper>
                  <Table
                    columns={filteredAccountColumns}
                    dataSource={transformedAccountData}
                    pagination={false}
                    bordered
                    scroll={{ x: "max-content", y: "60vh" }}
                    sticky={{ offsetHeader: 0 }}
                  />
                </StyledTableWrapper>
              ))}

            {activeTab === "3" &&
              (isFetchingSaasData ? (
                <Loader />
              ) : (
                <StyledTableWrapper>
                  <Table
                    columns={allSaasAccountColumns}
                    dataSource={transformedSaasData}
                    pagination={false}
                    bordered
                    scroll={{ x: "max-content", y: "60vh" }}
                    sticky={{ offsetHeader: 0 }}
                  />
                </StyledTableWrapper>
              ))}
            <Modal
              title="Delete 1099 Tax Document"
              onOk={handleDeleteOk}
              visible={w2deletionModal}
              onCancel={handleDeleteCancel}
            >
              <p>Are you sure you want to delete this 1099 Tax Document?</p>
            </Modal>
            <Modal
              title="Upload 1099 Tax Document"
              visible={isW2ModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              okText="Upload"
            >
              {isFetchingW2 ? (
                <Loader width="25px" top={0} bottom={0} />
              ) : (
                <>
                  <Upload
                    maxCount={1}
                    fileList={selectedW2File ? [selectedW2File] : []}
                    onRemove={handleRemove}
                    showUploadList={{
                      showRemoveIcon: true,
                    }}
                    beforeUpload={handleUpload}
                    action={(file) => handleUpload(file)}
                  >
                    <ClassicButton type="primary" icon={<UploadOutlined />}>
                      Select file (Max: 1){" "}
                    </ClassicButton>
                  </Upload>
                </>
              )}
            </Modal>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
                marginTop: "5px",
                marginBottom: "10px",
              }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom:"6px" }}>
          <p style={{ margin: 0 }}>Rows per page:</p>
          <Select
            defaultValue={100}
            style={{
              width: 80, // Reduced width
              fontSize: "10px", // Matches the font size of the p tag
              height: "26px", // Reduced height
              lineHeight: "10px",
              padding:0,
              borderRadius: 0 // Aligns text vertically
            }}
            onChange={handleLimitChange}
          >
            <Option value={10}>10</Option>
            <Option value={25}>25</Option>
            <Option value={50}>50</Option>
            <Option value={100}>100</Option>
            <Option value={200}>200</Option>
          </Select>
        </div>
              <p style={{ marginTop: "3px" }}>
                Showing {skip + 1} –{" "}
                {getPaginationValues.totalCount < limit + skip
                  ? skip + fetchedCount
                  : skip + 100}
              </p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  disabled={skip === 0}
                  onClick={() => setSkip(skip - limit)}
                  style={{ marginRight: 8 }}
                >
                  Previous
                </Button>
                <Button
                  disabled={fetchedCount < limit}
                  onClick={() => {
                    const { skip, setSkip } = getPaginationValues();
                    setSkip((prev) => {
                      return prev + limit;
                    });
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          </FilterWrap>
        </BorderWrap>
      </OuterWrap>
    </div>
  );
};

// export default FilterBoard;
export default teamContainer(agentSearchContainer(container(FilterBoard)));
